import { collection, query, where, getDocs, orderBy } from 'firebase/firestore';
import { db } from '../lib/firebase';

export interface RushdTreat {
  id: string;
  productId: string;
  productName: string;
  productImage?: string | null;
  quantity: number;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

const COLLECTION = 'rushdTreats';

export const getActiveRushdTreats = async (): Promise<RushdTreat[]> => {
  const treatsRef = collection(db, COLLECTION);
  const q = query(treatsRef, where('isActive', '==', true), orderBy('createdAt', 'desc'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map((docSnap) => {
    const data = docSnap.data();
    return {
      id: docSnap.id,
      productId: data.productId,
      productName: data.productName,
      productImage: data.productImage || null,
      quantity: data.quantity || 1,
      isActive: data.isActive ?? true,
      createdAt: data.createdAt?.toDate?.() || new Date(),
      updatedAt: data.updatedAt?.toDate?.() || new Date(),
    } as RushdTreat;
  });
};

